import { Injectable } from '@angular/core';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';
import { ReplaySubject, Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {
  private groups = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateGroups = () => {
    var path = `/group-codes`
    return this.cms.request('GET', path).pipe(
      first(),
      map(data => {
        this.groups.next(data.data)
        return data.data
      })
    )
  }

  public getGroups = (): Observable<any> => {
    return this.groups.asObservable()
  }
}
